import React, { SetStateAction, useContext, useRef, useState } from 'react'
import { DarkModeIcon, LightModeIcon, PasswordIcon, UsernameIcon } from '../../components/iconSet/IconSet'
import { ThemeTypes } from '../../context/ContextTypes'

/* Import images */
//import logoIcon from '../../images/icons/logo.png'
import logoIcon from '../../images/icons/logo.png'
import { useNavigate } from 'react-router-dom'
//import { generateCodeChallenge, generateCodeVerifier } from '../../utils/pkceUtils'
import { APICall, DATA_VALIDATION_ERROR, USER_CREDENTIALS_ERROR } from '../../services/APIService'
import { API_LOGIN_URL, APILoginType } from '../../services/APIAuthorizationService'
import { useTheme } from '../../context/ThemeContext'
import { generatePKCE } from '../../utils/keycloakPKCEUtils'
import AlertDialog from '../../components/popupComp/AlertDialog'
import { useUserData } from '../../context/UserDataContext'

const LoginPage = () => {
    const navigate = useNavigate()
    // Theme context
    const {theme, setTheme} = useTheme()

    const usernameRef = useRef<HTMLInputElement | null>(null)
    const passwordRef = useRef<HTMLInputElement | null>(null)

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

    const showAlertDialog = (title: string, description: string, callback?: () => void) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertCallback(() => callback); // wrap in function to preserve reference
    setAlertDialogState(true);
    };

    const [error, setError] = useState<string | null>(null);

    const [isAuthenticating, setIsAuthenticating] = useState(false);

    /* Handle login */
    const handleLoginButtonClick = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (usernameRef.current && passwordRef.current) 
        {
            try 
            {
                const cdeChallenge = await generatePKCE();
                
                const requestBody: APILoginType = {
                    username: usernameRef.current.value,
                    password: passwordRef.current.value,
                    codeChallenge: cdeChallenge
                };
    
                const response = await APICall(API_LOGIN_URL, 'POST', requestBody);
                if (response.access_token) 
                {
                    //console.log("username", response.preferred_username);
                    localStorage.setItem("access_token", response.access_token);
                    localStorage.setItem("refresh_token", response.refresh_token);
                    sessionStorage.setItem("access_token", response.access_token);
                    sessionStorage.setItem("refresh_token", response.refresh_token);

                    // await refetch()
                    // //window.location.href = '/callback';
                    navigate('/callback', { state: response });
                } 
                else if (response.error) 
                {
                    console.log('Login error:', response.error);
                    // Handle error display to user
                }
            } catch (error: any) {
                const backendDetails = error?.details;
                const backendError = error?.message;

                console.log("Backend details:", backendDetails); // should now print "Account is inactive"
                console.log("Backend error:", backendError); 

                // Network / server error (fetch never reached backend)
                if (error instanceof TypeError && error.message === "Failed to fetch") 
                {
                    showAlertDialog(
                        "Connection Error",
                        "🌐 Unable to reach server. Please check your internet connection or try again later."
                    )
                    return
                }

                if (error instanceof Error && error.message === 'Access denied') {
                    showAlertDialog("Login Failed", "❗Access denied");
                }else if(backendDetails === 'Account is inactive'){
                    showAlertDialog("Login Blocked", `🚫 ${backendError}`);
                } else {
                    showAlertDialog("Login Failed", "❌ Username or password incorrect");
                }

                console.error('Login failed:', error);
                // Handle error display to user
            }
        }
    };

    /* Handle forget password click */
    const handleNavigateForgotPassword = () => {
         navigate('/forgotpassword')
    }

    /* Handle theme change button click */
    const handleThemeChangeClick = (type: ThemeTypes) => {
        setTheme(prevState => type)
    }

    return (
        <div className={`login-page-wrapper ${theme}`}>
            <div className={`login-container`}>
                <div className={`form-area`}>
                    <span className={`title`}>login</span>
                    <div className={`input-wrapper`}>
                        <i>
                            <UsernameIcon color='var(--color-main-white)' width='1.2rem' />
                        </i>
                        <input type="text" placeholder='Username' ref={usernameRef} />
                    </div>
                    <div className={`input-wrapper`}>
                        <i>
                            <PasswordIcon color='var(--color-main-white)' width='1.2rem' />
                        </i>
                        <input type="password" placeholder='Password' ref={passwordRef} />
                    </div>
                    <div className={`button-wrapper`}>
                        <button className={`button-full`} onClick={(e) => handleLoginButtonClick(e)}>login</button>
                    </div>
                    <div className={`extra-wrapper`}>
                        <div className={`check-box-wrapper`}>
                            <input type='checkbox' id='login-remember-me' />
                            <label htmlFor="login-remember-me">remember me</label>
                        </div>
                        <span onClick={handleNavigateForgotPassword}>forgot password ?</span>
                    </div>
                </div>
                <div className={`logo-area`}>
                    <img className={`logo-image`} src={logoIcon} alt="" />
                    <span className='title'>BCONX</span>
                    <span className='water-mark'>Powered by Tecxal Systems</span>
                </div>

                {theme === 'dark' ? (
                    <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('light')}>
                        <LightModeIcon color='white' width='2rem' />
                    </div>
                ) : theme === 'light' ? (
                    <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('dark')}>
                        <DarkModeIcon color='white' width='1rem' />           
                    </div>
                ) : null}
                
            </div>
            {alertDialogState && (
                <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertCallback}
                />
            )}
        </div>
    )
}

export default LoginPage